{
  "page_intro": "การ์ดและสินค้าทั้งหมด: ขายที่ไหน สภาพ ราคา และเป็นของใคร",
  "empty": "ไม่มีสินค้าที่ตรง ลองเปลี่ยนตัวกรอง — หรือลงการ์ดใหม่",
  "export_shopify": "ดาวน์โหลดสำหรับ Shopify (CSV)",
  "no_photo": "ไม่มีรูป",
  "cert": "เลข cert",
  "consigned": "ของฝากขาย",
  "warnings_other": "ต้องแก้ {{count}} จุด",
  "condition": {
    "rank_missing": "ต้องระบุ Rank",
    "sealed": "ยังไม่แกะ (未開封)",
    "rank": "Rank {{rank}}"
  },
  "status": {
    "active": "ขายอยู่",
    "draft": "ร่าง",
    "archived": "เก็บเข้าคลัง",
    "other": "อื่นๆ"
  },
  "types": {
    "raw_single": "การ์ด (raw)",
    "graded_single": "การ์ดเกรด",
    "sealed_product": "สินค้ายังไม่แกะ",
    "supplies": "อุปกรณ์เสริม"
  },
  "filters": {
    "q": "ค้นหา",
    "q_placeholder": "ชื่อ รหัสสินค้า เลข cert",
    "status": "สถานะ",
    "type": "ประเภท",
    "rank": "Rank",
    "game": "เกม",
    "set": "ชุด",
    "set_placeholder": "รหัสหรือชื่อชุด เช่น SV2a",
    "price": "ราคา (รวมภาษี)",
    "stock": "สต็อก",
    "consigned": "ของฝากขาย",
    "has_media": "มีรูป",
    "tag": "แท็ก",
    "price_check": "ตรวจราคา",
    "price_check_warn": "ใกล้ถึงเวลาตรวจ (เหลือง + แดง)",
    "price_check_alert": "เลยเวลาตรวจ (แดง)"
  },
  "stock": {
    "in_stock": "มีของ",
    "sold_out": "หมด",
    "unknown": "ยังไม่นับ",
    "sold": "ขายแล้ว",
    "held": "ถูกจองอยู่",
    "kinds_other": "มีของ {{n}} จาก {{count}} แบบ"
  },
  "price_check": {
    "today": "วันนี้",
    "yesterday": "เมื่อวาน",
    "days_ago_other": "{{count}} วันที่แล้ว",
    "check_soon": "ใกล้ถึงเวลาตรวจ",
    "overdue": "เลยเวลา — ตรวจราคาด้วย",
    "not_counted": "ไม่นับ (ขายแล้วหรือเก็บเข้าคลัง)",
    "checked_on": "ตรวจราคา {{date}}",
    "changed_on": "เปลี่ยนราคา {{date}}",
    "editor_title": "ราคานี้ยังถูกต้องไหม?",
    "editor_line": "ตรวจราคาล่าสุด {{age}} ({{date}})",
    "still_right": "ราคานี้ยังถูกต้อง",
    "still_right_saving": "กำลังบันทึก…",
    "save_first": "บันทึกราคาใหม่ก่อน — การบันทึกราคาใหม่นับเป็นการตรวจแล้ว",
    "confirmed": "บันทึกว่าตรวจราคาแล้ว",
    "hint": "ไม่ได้ตรวจเกิน {{warn}} วันจะเป็นสีเหลือง เกิน {{alert}} วันเป็นสีแดง — การแก้ราคาก็นับเป็นการตรวจ"
  },
  "channels": {
    "web": "เว็บ",
    "none": "ไม่ได้ขายบนเว็บ"
  },
  "columns": {
    "image": "รูป",
    "title": "ชื่อ",
    "code": "รหัสสินค้า",
    "card": "เกม / ชุด / เลข",
    "condition": "สภาพ",
    "price": "ราคา (รวมภาษี)",
    "price_check": "ตรวจราคาล่าสุด",
    "stock": "สต็อก",
    "channels": "ขายที่",
    "consigned": "ผู้ฝาก",
    "status": "สถานะ",
    "updated": "แก้ล่าสุด"
  },
  "views": {
    "active": "ขายอยู่",
    "drafts": "ร่าง",
    "consigned_draft": "ของฝากขายที่ยังไม่ลงขาย",
    "sold": "ขายแล้วรอส่ง",
    "no_photos": "ไม่มีรูป",
    "active_no_photos": "ขายอยู่แต่ไม่มีรูป",
    "prices_to_check": "ราคาที่ต้องตรวจ"
  },
  "bulk": {
    "publish": "เปิดขาย",
    "unpublish": "ปิดขาย",
    "add_tag": "เพิ่มแท็ก",
    "tag_label": "แท็ก",
    "tag_add": "ใส่แท็ก",
    "add_collection": "เพิ่มเข้าคอลเลกชัน",
    "collection_label": "หาคอลเลกชัน",
    "collections_error": "โหลดคอลเลกชันไม่ได้",
    "collections_empty": "ไม่พบคอลเลกชันแบบเลือกเอง",
    "price": "ปรับราคา %",
    "archive": "เก็บเข้าคลัง",
    "channels": "ส่งไปขายช่องทางอื่น",
    "channels_later": "ช่องทาง eBay, Whatnot ฯลฯ มาในเฟสถัดไป",
    "partly": "สำเร็จ {{ok}} รายการ, เปลี่ยนไม่ได้ {{failed}} รายการ",
    "partly_hint": "เปิดสินค้าที่มี “ต้องแก้” เพื่อดูเหตุผล",
    "unpublished_other": "ปิดขาย {{count}} รายการแล้ว",
    "published_other": "เปิดขาย {{count}} รายการแล้ว",
    "tagged_other": "ใส่แท็ก “{{tag}}” ให้ {{count}} รายการแล้ว",
    "collected_other": "เพิ่ม {{count}} รายการเข้า “{{name}}” แล้ว",
    "priced_other": "ปรับราคา {{count}} รายการแล้ว",
    "archived_other": "เก็บเข้าคลัง {{count}} รายการแล้ว",
    "archive_title_other": "เก็บ {{count}} รายการเข้าคลัง?",
    "archive_consequence": "สินค้าจะหายจากเว็บและ POS — เอากลับมาได้ภายหลังจากมุมมองที่เก็บเข้าคลัง",
    "archive_confirm": "เก็บเข้าคลัง",
    "price_title": "ปรับราคาเป็นเปอร์เซ็นต์",
    "price_consequence_empty_other": "ใส่เปอร์เซ็นต์สำหรับ {{count}} รายการ",
    "price_consequence_up_other": "ราคา {{count}} รายการจะขึ้น {{percent}} % ปัดเป็นเยนเต็ม (รวมภาษี)",
    "price_consequence_down_other": "ราคา {{count}} รายการจะลง {{percent}} % ปัดเป็นเยนเต็ม (รวมภาษี)",
    "price_percent": "ปรับ",
    "price_percent_hint": "เลขเต็มตั้งแต่ {{min}} ถึง {{max}} เช่น -10 = ถูกลง 10 %",
    "price_reason_placeholder": "เช่น ราคาตลาดลง, ลดราคาสุดสัปดาห์",
    "price_confirm_other": "ปรับราคา {{count}} รายการ",
    "confirm_prices": "บันทึกว่าตรวจราคาแล้ว",
    "confirm_prices_title_other": "บันทึกว่าตรวจราคาการ์ด {{count}} ใบแล้ว?",
    "confirm_prices_consequence": "จำนวนวัน “ตรวจราคาล่าสุด” จะเริ่มนับใหม่จากวันนี้ — ราคาไม่เปลี่ยน",
    "confirm_prices_confirm": "ใช่ ราคาถูกต้อง",
    "prices_confirmed_other": "บันทึกว่าตรวจราคาแล้ว {{count}} รายการ"
  },
  "row": {
    "actions": "เพิ่มเติมสำหรับ {{title}}",
    "duplicated": "ทำสำเนาเป็นร่างแล้ว",
    "view_on_web": "ดูบนเว็บ",
    "view_on_web_off": "ดูบนเว็บ (ยังไม่ขาย)",
    "duplicate": "ทำสำเนา",
    "print_label": "พิมพ์ป้ายราคา",
    "print_label_later": "ใช้ได้เมื่อต่อเครื่องพิมพ์ป้ายของ POS"
  },
  "detail": {
    "not_found": "ไม่มีสินค้านี้ (หรือถูกลบแล้ว)",
    "updated": "แก้ล่าสุด",
    "pictures": "รูป",
    "items": "สภาพและราคา"
  },
  "quick": {
    "title": "ลงการ์ด",
    "intro": "4 ขั้นสั้นๆ — ประมาณ 2 นาที สิ่งที่พิมพ์จะเก็บไว้ในเครื่องนี้",
    "progress_label": "ขั้นตอน",
    "step_of": "ขั้นที่ {{n}} จาก {{total}}: {{name}}",
    "steps": {
      "card": "การ์ด",
      "condition": "สภาพ",
      "pricing": "ราคา",
      "photos": "รูป",
      "summary": "ตรวจและบันทึก"
    },
    "headings": {
      "card": "การ์ดใบไหน?",
      "condition": "สภาพเป็นอย่างไร?",
      "pricing": "ราคา จำนวน และที่เก็บ",
      "photos": "ถ่ายหรือเพิ่มรูป"
    },
    "next": "ถัดไป",
    "back": "ย้อนกลับ",
    "publish": "ลงขายเลย",
    "save_draft": "บันทึกร่าง",
    "card": {
      "label": "การ์ดใบไหน?",
      "change": "เลือกการ์ดใบอื่น",
      "not_a_card": "เป็นกล่องหรือซองที่ยังไม่แกะ ไม่ใช่การ์ดใบเดียว",
      "free_title": "ชื่อสินค้า",
      "free_title_hint": "เช่น Pokémon 151 booster box (ภาษาญี่ปุ่น)",
      "back_to_list": "เป็นการ์ดจริงๆ — เลือกจากรายการการ์ด",
      "cert_kept": "เก็บเลขการ์ดเกรด {{cert}} ไว้แล้ว — เลือกว่าเป็นการ์ดใบไหน"
    },
    "condition": {
      "kind": "เป็นอะไร?",
      "raw_single": "การ์ด",
      "raw_single_hint": "การ์ดธรรมดา — เลือก Rank",
      "graded_single": "การ์ดเกรด",
      "graded_single_hint": "อยู่ในเคส (PSA, BGS, CGC …)",
      "sealed_product": "ซีล",
      "sealed_product_hint": "กล่องหรือซองที่ยังไม่แกะ",
      "rank_note": "หมายเหตุสภาพสั้นๆ (ไม่บังคับ)",
      "rank_note_hint": "เช่น รอยเล็กด้านหลัง ลูกค้าจะเห็น",
      "quantity": "จำนวน",
      "weight": "น้ำหนักรวมกล่อง (กรัม)",
      "weight_hint": "ใช้คิดค่าส่ง — วางกล่องบนตาชั่ง",
      "box": "สภาพกล่อง (ไม่บังคับ)",
      "box_hint": "เช่น ซีลครบ มุมบุบเล็กน้อย"
    },
    "graded": {
      "company": "บริษัทเกรด",
      "grade": "เกรด",
      "psa_whole": "PSA ให้เกรดเป็นจำนวนเต็มเท่านั้น",
      "other": "อื่นๆ",
      "label": "ป้ายบนเคส",
      "label_hint": "กรอกให้อัตโนมัติ — แก้ได้ถ้าบนเคสเขียนต่างไป",
      "cert": "เลข cert",
      "cert_hint": "เลขบนป้ายเคส (สแกนบาร์โค้ดได้)",
      "cert_format": "ดูไม่เหมือนเลขของ {{company}} ปกติ — ตรวจอีกครั้ง (ยังบันทึกได้)",
      "checking": "กำลังตรวจ…",
      "cert_taken": "การ์ดเกรดใบนี้ลงไว้แล้ว: {{title}}",
      "open_existing": "ดูใบเดิม"
    },
    "pricing": {
      "price": "ราคาขาย",
      "cost": "ต้นทุน/ราคารับซื้อ (ไม่บังคับ)",
      "cost_hint": "เห็นเฉพาะพนักงาน — ใช้ดูกำไร",
      "tax_note": "ใส่ราคารวมภาษี ระบบจะคำนวณราคาก่อนภาษีและภาษี 10% ตอนบันทึก แล้วแสดงให้เห็น",
      "below_cost": "ราคาต่ำกว่าต้นทุน ทำได้ — แค่ตรวจว่าตั้งใจ",
      "compare_at_on": "แสดงราคาอ้างอิง (ราคาปกติ/ราคาตั้ง)",
      "keihyo": "กฎหมายญี่ปุ่น (景品表示法) กำหนดให้ราคาอ้างอิงต้องมีที่มาจริง — ถ้าไม่มี ลูกค้าจะไม่เห็น",
      "compare_at": "ราคาอ้างอิง",
      "evidence": "ราคาอ้างอิงมาจากไหน?",
      "evidence_own_price_history": "ร้านเคยขายราคานี้จริง",
      "evidence_own_price_history_hint": "ระบบตรวจประวัติราคาให้ (ต้องเป็นราคานี้นานพอใน 8 สัปดาห์ที่ผ่านมา)",
      "evidence_market_survey": "สำรวจราคาเทียบร้านอื่น",
      "evidence_market_survey_hint": "เขียนว่าเทียบราคาอย่างไรและเมื่อไร",
      "evidence_msrp": "ราคาตั้งของผู้ผลิต",
      "evidence_msrp_hint": "เฉพาะสินค้าซีล — ใส่หน้าเว็บผู้ผลิตและวันที่",
      "evidence_url": "หน้าเว็บที่มา",
      "evidence_date": "วันที่ตรวจ",
      "evidence_method": "วิธีเทียบราคา",
      "quantity": "จำนวน",
      "quantity_locked": "การ์ดชิ้นเดียว — เป็น 1 เสมอ",
      "location": "เก็บที่ไหน"
    },
    "consignor": {
      "consigned": "การ์ดนี้เป็นของฝากขาย (委託)",
      "label": "การ์ดของใคร?",
      "placeholder": "ชื่อ หรือเลข CON-",
      "results": "ผู้ฝากขาย",
      "verified": "ยืนยันตัวตนแล้ว (本人確認)",
      "not_verified": "ยังไม่ได้ยืนยันตัวตน (本人確認)",
      "status": {
        "pending_verification": "รอยืนยันตัวตน",
        "suspended": "พักไว้",
        "closed": "ปิดแล้ว"
      },
      "choose": "เลือก",
      "fix": "ทำก่อน",
      "change": "เปลี่ยน",
      "error": "โหลดรายชื่อผู้ฝากขายไม่ได้",
      "agreed": "ราคาต่ำสุดที่ตกลงกับผู้ฝาก (ไม่บังคับ)",
      "agreed_hint": "ถ้าลดต่ำกว่านี้ต้องถามผู้ฝากก่อน",
      "commission": "ค่าคอมของร้าน (ไม่บังคับ)",
      "commission_hint": "เว้นว่าง = อัตราปกติของผู้ฝาก",
      "discount": "อนุญาตส่วนลด (ไม่เกิน {{max}}%)"
    },
    "photos": {
      "label": "รูปการ์ด",
      "hint": "ถ่ายด้วยกล้องมือถือหรือเลือกไฟล์ ต้องมีรูปอย่างน้อย 1 รูปถึงจะลงขายได้ บันทึกร่างได้โดยไม่มีรูป",
      "wait": "รูปยังอัปโหลดอยู่ — รอสักครู่"
    },
    "summary": {
      "title": "ชื่อบนเว็บ",
      "title_auto": "สร้างจากการ์ดให้อัตโนมัติ — แก้ได้",
      "title_own": "ชื่อที่ตั้งเอง",
      "card": "การ์ด",
      "condition": "สภาพ",
      "price": "ราคา",
      "stock": "สต็อก",
      "photos": "รูป",
      "change": "แก้{{what}}",
      "tax_after": "ราคาก่อนภาษีและภาษีจะแสดงหลังบันทึก (ระบบคำนวณ)",
      "compare_at": "ราคาอ้างอิง {{price}}",
      "cost": "ต้นทุน {{price}}",
      "stock_at_other": "{{count}} ชิ้น ที่ {{where}}",
      "consigned": "ของฝากขาย — {{name}}",
      "photo_count_other": "{{count}} รูป",
      "no_photos": "ยังไม่มีรูป (ต้องมีถึงจะลงขายได้)"
    },
    "problems": {
      "card_required": "เลือกการ์ด (หรือ \"กล่องซีล\")",
      "title_required": "ใส่ชื่อสินค้า",
      "rank_required": "เลือกสภาพการ์ด A–D",
      "company_required": "เลือกบริษัทเกรด",
      "grade_required": "เลือกเกรด",
      "cert_required": "ใส่เลข cert",
      "cert_taken": "เลข cert นี้ลงไว้แล้ว",
      "quantity_invalid": "ใส่จำนวนเต็มตั้งแต่ 1",
      "weight_required": "ใส่น้ำหนักเป็นกรัม (ตั้งแต่ 1)",
      "price_required": "ใส่ราคาเป็นเยน (ตั้งแต่ 1)",
      "compare_at_required": "ใส่ราคาอ้างอิง",
      "compare_at_not_higher": "ราคาอ้างอิงต้องสูงกว่าราคาขาย",
      "evidence_required": "เลือกที่มาของราคาอ้างอิง",
      "evidence_url_required": "ใส่หน้าเว็บที่มา",
      "evidence_date_required": "ใส่วันที่",
      "evidence_method_required": "เขียนวิธีเทียบราคา",
      "msrp_cards": "การ์ดไม่มีราคาตั้งของผู้ผลิต — เลือกที่มาอื่น",
      "location_required": "เลือกที่เก็บ",
      "consignor_required": "เลือกผู้ฝากขาย",
      "commission_invalid": "ใส่ตัวเลข 0 ถึง 100",
      "photo_required": "เพิ่มรูปอย่างน้อย 1 รูปเพื่อลงขาย (หรือบันทึกร่าง)"
    },
    "done": {
      "title": "บันทึกแล้ว",
      "price": "ราคา (รวมภาษี)",
      "excl": "ก่อนภาษี",
      "tax": "ภาษีบริโภค {{rate}}%",
      "toast_listed": "\"{{title}}\" ลงขายแล้ว",
      "toast_draft": "บันทึก \"{{title}}\" เป็นร่างแล้ว",
      "not_listed": "บันทึกพร้อมสต็อกแล้ว แต่ยังไม่ได้ลงขาย:",
      "publish_problem": "ยังขาดบางอย่าง — เปิดการ์ดเพื่อดู",
      "next": "ลงใบต่อไป",
      "same": "ลงใบเดิมซ้ำ (เปลี่ยนเลข ราคา รูป)",
      "open": "เปิดการ์ด"
    },
    "failure": {
      "nothing_saved": "ยังไม่มีอะไรถูกบันทึก",
      "product_after_save": "ยังไม่มีอะไรถูกบันทึก",
      "stock_after_save": "บันทึกการ์ดเป็นร่างแล้ว แต่ยังไม่ได้บันทึกสต็อก กด \"ลองอีกครั้ง\" — ไม่เกิดซ้ำ",
      "intake_after_save": "บันทึกการรับฝากแล้ว แต่การ์ดยังไม่พร้อม กด \"ลองอีกครั้ง\"",
      "publish_after_save": "บันทึกการ์ดและสต็อกแล้ว แต่ลงขายไม่ได้",
      "load_after_save": "บันทึกแล้ว — แสดงผลไม่ได้ เปิดการ์ดเพื่อดู",
      "retry": "ลองอีกครั้ง",
      "open": "เปิดการ์ดที่บันทึก"
    }
  },
  "edit": {
    "jump": "ไปที่ส่วน",
    "short": {
      "1": "การ์ด",
      "2": "ชื่อ",
      "3": "สภาพ",
      "4": "ราคา",
      "5": "หมวด",
      "6": "รูป",
      "7": "รายละเอียด",
      "8": "ฝากขาย",
      "9": "ช่องทาง",
      "10": "ค้นหาและสถานะ"
    },
    "sections": {
      "card": "การ์ด",
      "title": "ชื่อและคำอธิบาย",
      "condition": "สภาพ",
      "pricing": "ราคาและสต็อก",
      "tags": "หมวดและแท็ก",
      "media": "รูป",
      "details": "รายละเอียด",
      "consignment": "ฝากขาย",
      "channels": "ขายที่ไหน",
      "seo": "เครื่องมือค้นหาและสถานะ"
    },
    "hints": {
      "card": "สินค้านี้คือการ์ดใบไหนในคลังข้อมูลการ์ด",
      "media": "รูปแรกคือรูปหลัก ลากเพื่อเปลี่ยนลำดับ"
    },
    "change_card": "เปลี่ยนการ์ด",
    "keep_card": "ใช้การ์ดเดิม",
    "no_card": "ยังไม่ได้ผูกกับการ์ดในแคตตาล็อก",
    "title": "ชื่อสินค้า",
    "title_required": "ชื่อสินค้าเว้นว่างไม่ได้",
    "description": "คำอธิบาย",
    "description_hint": "เว้นบรรทัดว่างเพื่อขึ้นย่อหน้าใหม่",
    "languages": "ชื่อและคำอธิบายภาษาอื่น",
    "rank_note": "หมายเหตุสภาพ",
    "saved_price": "ที่บันทึกอยู่:",
    "excl": "ก่อนภาษี",
    "tax": "ภาษี {{rate}}%",
    "compare_at_verified": "ราคาอ้างอิงตรวจแล้ว",
    "compare_at_unverified": "ราคาอ้างอิงยังไม่แสดง (ยังไม่มีที่มา)",
    "single_stock": "การ์ดชิ้นเดียว: สต็อกเป็น 1 ตอนที่อยู่ในร้าน",
    "stock_hint": "เปลี่ยนสต็อกที่หน้าสต็อก (รับเข้า/ปรับพร้อมเหตุผล)",
    "open_stock": "เปิดสต็อก",
    "category": "หมวด",
    "no_category": "ไม่มีหมวด",
    "vendor": "ผู้ผลิต",
    "tags": "แท็ก",
    "tags_hint": "คั่นด้วยจุลภาค เช่น SAR, 151",
    "collections": "คอลเลกชันที่เลือกเอง",
    "no_collections": "ยังไม่มีคอลเลกชันแบบเลือกเอง",
    "smart_matches": "อยู่ในคอลเลกชันตามเงื่อนไขด้วย:",
    "read_only": "ดูรูปได้แต่แก้ไม่ได้",
    "detail_text": "รายละเอียดเพิ่มเติม",
    "detail_text_hint": "แสดงบนหน้าสินค้าใต้คำอธิบาย",
    "consigned": "การ์ดนี้เป็นของฝากขาย",
    "open_consignment": "เปิดของฝากขาย",
    "shop_own": "ของร้านเอง",
    "channel_web": "เว็บ",
    "channel_pos": "หน้าร้าน (POS)",
    "layout": "รูปแบบหน้า",
    "layout_hint": "เว้นว่างไว้ถ้าใช้แบบมาตรฐาน",
    "status": "สถานะ",
    "publish_at": "ตั้งเวลาลงขาย (เวลาญี่ปุ่น)",
    "publish_at_hint": "เว้นว่างไว้ถ้ายังเป็นร่าง",
    "trash": "ย้ายไปถังขยะ",
    "trash_title": "ย้ายสินค้านี้ไปถังขยะ?",
    "trash_body": "สินค้าจะหายจากเว็บ สต็อกและประวัติยังอยู่ กู้คืนได้ภายใน 30 วัน",
    "trashed": "ย้ายไปถังขยะแล้ว",
    "in_trash": "สินค้านี้อยู่ในถังขยะ",
    "save": "บันทึก",
    "saved": "บันทึกแล้ว",
    "nothing_changed": "ไม่มีอะไรเปลี่ยน",
    "fix_first": "แก้ส่วนที่ขีดสีแดงก่อน",
    "rank_confirm_title": "เปลี่ยน Rank ของการ์ดที่ขายอยู่?",
    "rank_confirm_body": "ลูกค้าจะเห็น Rank ใหม่ทันที เขียนเหตุผล (เก็บในประวัติ)",
    "rank_confirm": "เปลี่ยน Rank",
    "side_label": "สรุปสินค้านี้",
    "side": {
      "status": "ตอนนี้",
      "stock": "สต็อกแต่ละที่",
      "stock_error": "โหลดสต็อกไม่ได้",
      "no_stock": "ยังไม่มีสต็อก",
      "available": "พร้อมขาย {{available}} จาก {{onHand}}",
      "receive": "รับของเข้า",
      "price_history": "ประวัติราคา",
      "no_history": "ยังไม่เคยเปลี่ยน",
      "changes": "การเปลี่ยนล่าสุด",
      "no_changes": "ยังไม่มีบันทึกการเปลี่ยน",
      "all_history": "ดูประวัติทั้งหมด"
    }
  },
  "translations": {
    "tabs": "ภาษา",
    "locale": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh-Hant": "繁體中文",
      "zh-Hans": "简体中文"
    },
    "copy_all": "คัดลอกจากอังกฤษไปทุกภาษา",
    "copy_one": "คัดลอกจากอังกฤษ",
    "mark_checked": "ตรวจแล้ว",
    "suggest": "แนะนำคำแปล",
    "empty_badge": "ว่าง",
    "unchecked_badge": "ต้องตรวจ",
    "copied_mark": "คัดลอกจาก en ยังไม่ตรวจ",
    "still_empty": "ยังว่าง",
    "en_hint": "ภาษาอังกฤษคือข้อความหลัก — ภาษาอื่นที่ว่างจะแสดงภาษาอังกฤษแทน",
    "unchecked_count_other": "ข้อความที่คัดลอกมายังไม่ตรวจ {{count}} ข้อความ"
  },
  "seo": {
    "heading": "เครื่องมือค้นหา",
    "preview": "หน้าตาบน Google",
    "title": "ชื่อบน Google",
    "description": "คำอธิบายบน Google",
    "count": "{{count}} / {{max}}",
    "address": "ที่อยู่เว็บ",
    "address_changed": "ลิงก์เก่ายังใช้ได้ — จะพาไปที่อยู่ใหม่"
  },
  "variants": {
    "name": "ตัวเลือก (เช่น กล่อง/ซอง)",
    "name_n": "ชื่อตัวเลือกที่ {{n}}",
    "price": "ราคา (รวมภาษี)",
    "price_n": "ราคาตัวเลือกที่ {{n}}",
    "cost": "ต้นทุน",
    "cost_n": "ต้นทุนตัวเลือกที่ {{n}}",
    "barcode": "บาร์โค้ด (JAN)",
    "barcode_n": "บาร์โค้ดตัวเลือกที่ {{n}}",
    "weight": "น้ำหนัก (g)",
    "weight_n": "น้ำหนักตัวเลือกที่ {{n}}",
    "remove": "ลบ",
    "remove_n": "ลบตัวเลือกที่ {{n}}",
    "add": "เพิ่มตัวเลือก",
    "excl": "ก่อนภาษี"
  },
  "attributes": {
    "list_hint": "บรรทัดละหนึ่งค่า",
    "reference_hint": "รหัสของสิ่งที่เชื่อมอยู่",
    "structured_hint": "สำหรับผู้ชำนาญ — ถามเจ้าของร้านก่อนแก้",
    "problems": {
      "required": "กรุณากรอกช่องนี้",
      "not_integer": "ใส่จำนวนเต็ม",
      "not_number": "ใส่ตัวเลข",
      "below_min": "อย่างน้อย {{min}}",
      "above_max": "ไม่เกิน {{max}}",
      "too_long": "ไม่เกิน {{maxLength}} ตัวอักษร",
      "regex_mismatch": "รูปแบบไม่ถูก",
      "not_in_choices": "เลือกจากตัวเลือก",
      "not_url": "ใส่ที่อยู่เว็บ (https://…)",
      "not_date": "เลือกวันที่",
      "not_structured": "ข้อความนี้ไม่อยู่ในรูปแบบที่กำหนด",
      "too_many_items": "ไม่เกิน {{maxItems}} รายการ"
    }
  },
  "trash": {
    "title": "ถังขยะ",
    "intro": "สินค้าที่ลบใน {{days}} วันที่ผ่านมา กู้คืนเพื่อใช้อีก — สต็อกและประวัติยังอยู่",
    "empty": "ถังขยะว่าง",
    "days_left_other": "เหลือ {{count}} วัน",
    "restore": "กู้คืน",
    "restored": "กู้คืน \"{{title}}\" เป็นร่างแล้ว"
  },
  "publish_issues": {
    "title_missing": "ยังไม่มีชื่อสินค้า",
    "price_missing": "ยังไม่มีราคา",
    "raw_rank_missing": "ยังไม่ได้เลือก Rank (A–D)",
    "cert_missing": "ยังไม่มีเลข cert",
    "category_missing": "ยังไม่มีหมวด",
    "no_variant": "ยังไม่มีแถวราคา",
    "compare_at_unverified": "ราคาอ้างอิงยังไม่มีที่มา",
    "translation_ja_missing": "ยังไม่มีชื่อภาษาญี่ปุ่น",
    "other": "ยังขาดบางอย่าง ({{field}})"
  }
}
